module.exports = __webpack_public_path__ + "static/img01-3ddbef263d7fce93d04eb0a77bdc9456.jpeg";